
import Logout from "assets/images/Logout.svg";
import LogoutBlue from "assets/images/LogoutBlue.svg";
import Office from "assets/images/Office.svg";
import OfficeBlue from "assets/images/OfficeBlue.svg";
import Setting from "assets/images/Setting.svg";
import SettingBlue from "assets/images/SettingBlue.svg";

//admin Sidebar
export const adminSidebar = [
  {
    id: 8,
    field: "Company",
    path: "companies",
    keyword: "company",
    icon: Office,
    activeIcon: OfficeBlue,
  },
];

//Operation Module Sidebar
export const commonSideData = [
  {
    id: 8,
    field: "Company",
    path: "companies",
    keyword: "company",
    icon: Office,
    activeIcon: OfficeBlue,
  },
  {
    id: 27,
    field: "Settings",
    path: "settings",
    icon: Setting,
    activeIcon: SettingBlue,
  },
  {
    id: 28,
    field: "Logout",
    path: "",
    icon: Logout,
    activeIcon: LogoutBlue,
  },
];
